import { createFeatureSelector, createSelector } from '@ngrx/store';
import { addAccountFeatureKey, AddAccountState } from './add-account.reducer';

const getAddAccountFeature = createFeatureSelector<AddAccountState>(addAccountFeatureKey);

export const getAddAccountCallState = createSelector(getAddAccountFeature, (state) => {
   return state.callState;
});
